import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { AuthContextUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";

export const SummeryDoc = () => {

    const { currentUser } = useContext(AuthContextUser);

if (currentUser.tel === null) {
} else {
  return (
   <>
    <section class="m-0 content" dir='rtl'>

            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary">خلاصه پرونده</div>
                        <p class="card-subtitle">نمایش خلاصه پرونده</p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره پرونده" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام و نام خانوادگی" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-xl-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام پدر" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تاریخ تولد" />
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام بخش" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="شماره اتاق" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 me-xl-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="تخت" />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="پزشک معالج" />
                        </div>
                    </div>
                    <div class="seprator my-24"></div>
                    <div class="form-group position-relative w-100">
                        <div class="card-title text-secondary b-16">شکایت اصلی بیمار و تشخیص اولیه</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">تشخیص اولیه</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">اقدامات درمانی و اعمال جراحی</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">نتایج آزمایشات پاراکلینیکی</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">سیر بیماری (درصورت فوت علت را توضیح دهید)</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">وضعیت بیمار هنگام ترخیص</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                    <div class="form-group position-relative w-100 t-16">
                        <div class="card-title text-secondary b-16">توصیه های پس از ترخیص</div>
                        <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                            placeholder="آدرس">

                        </textarea>
                    </div>
                </div>
            </div>
        </section>
   </>
  )
  }
}
